// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--y3YRZ";
export var section = "styles-module--section--fABHB";
export var images = "styles-module--images--wkIzQ";
export var imageContainer = "styles-module--image-container--Xb+C2";
export var image = "styles-module--image--WEz4v";
export var caption = "styles-module--caption--0GIxN";